// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__15NoP","label":"CategoryService_label__2Qq6u","location":"CategoryService_location__2LaBm"};